import React from 'react';
import { Icon } from './Icon.js';
export const IconShapeTriangleFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m11.704,8.184L7.914,1.606c-.398-.693-1.114-1.106-1.914-1.106s-1.516.414-1.914,1.106L.296,8.184c-.399.692-.398,1.518,0,2.209s1.115,1.104,1.914,1.104h7.578c.799,0,1.515-.413,1.914-1.104s.4-1.518,0-2.209Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconShapeTriangleFill12.js.map